<template>
    <div v-if="hasResults">
        <div class="subcaption text-grey-600 px-3 mb-1">{{ props.contents.placeHolders.accommodations }}</div>

        <div
            v-for="accommodation in props.accommodations"
            @click="openProductPageUrl(accommodation)"
            class="cursor-pointer subcaption text-grey-900 cursor-pointer py-1 item px-3"
        >
            {{ accommodation.liheName }}
        </div>
    </div>
</template>

<script lang="ts" setup>
import {computed, ComputedRef} from "vue"

// Types
type Accommodation = { id: string; liheName: string; productPageUrl: string }

// Props
const props = defineProps<{
    accommodations: Accommodation[]
    store: any
    contents: any
}>()

// Methods
const openProductPageUrl = (accommodation: Accommodation): void => {
    const { startDate, endDate } = props.store.data.selected
    if (startDate && endDate) {
        window.open(`${accommodation.productPageUrl}${getFormattedDatesHashParams(startDate, endDate)}`, 'blank')
    } else {
        window.open(accommodation.productPageUrl, 'blank')
    }
}

const getFormattedDatesHashParams = (startDate: Date, endDate: Date): string => {
    if (!startDate) throw new Error('startDate is mandatory in getFormattedDates')
    if (!endDate) throw new Error('endDate is mandatory in getFormattedDates')
    const formattedStartDate = formatDate(startDate)
    const formattedEndDate = formatDate(endDate)
    return `#BeginDate=${formattedStartDate}&EndDate=${formattedEndDate}`
}

const formatMonthOrDay = (dayOrMonth: number): string => {
    if (dayOrMonth < 10) return '0' + dayOrMonth
    return dayOrMonth.toString()
}

const formatDate = (date: Date): string => {
    if (!date) throw new Error('date is mandatory in formatDate')
    const day = formatMonthOrDay(date.getDate())
    const month = formatMonthOrDay(date.getMonth() + 1) // JavaScript counts months from 0-11, so we need to add 1
    const year = date.getFullYear()

    // Construct the formatted date string
    const formattedDate = `${day}/${month}/${year}`
    return formattedDate
}

const hasResults: ComputedRef<number> = computed(() => {
    return props.accommodations.length
})
</script>
